import { useMutation } from 'react-query';

import { setComponentColumns as mutationFn } from 'api/endPoints/setComponentColumns';

export const useMutationSetComponentColumns = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>((params) => mutationFn(params));
};

interface WidgetColumns {
    columnOrder: string[];
    hiddenColumns: string[];
}

interface QueryParams {
    columns: WidgetColumns;
    widgetId?: string;
}

interface QueryResponse {
    columnOrder: string[];
    hiddenColumns: string[];
}
